export function constructMaterialsCommercialCondition(materialIds?: number[]) {
  if (!materialIds) return [];

  return materialIds.map((productId) => ({
    productId,
    formId: `${productId}`,
  }));
}
